module.exports = __webpack_public_path__ + "img/arena_e-sport.0faeb99d.png";